import { Component, ɵConsole } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { User, Master, Project} from '@providers/index';

@Component({
  selector: 'page-detail-usage',
  templateUrl: 'page.html'
})
export class DetailUsagePage {

  user:any={};
  params:any={};
  list:any=[];
  project_code = '';
  project_title='';
  total_amount=0;

  projek : any={};

  constructor(
    public navCtrl    : NavController,
    public masterApi  : Master,
    public projectApi : Project,
    public userApi    : User,
    public loadingCtrl: LoadingController,
    public navParams  : NavParams,
    public alertCtrl  : AlertController,
    public toastCtrl  : ToastController
    ) {
    
    this.project_code= navParams.get('project_code');
    this.project_title = navParams.get('project_title');
    this.user = this.userApi.data;

    this.getList();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getList();
  }

  // getDetailEmployee(){
  //   let loading = this.loadingCtrl.create({
  //     content: 'Please wait...'
  //   });
  //   loading.present();
  //   let params : any = {user_nik:this.user_nik}
  //   this.masterApi.getEmployee(params).subscribe((resp:any) => {
  //     this.projek = resp.data[0];

  //     console.log("data projek di klik = ",this.projek.name);
  //     console.log("employe detail => ", this.projek)
  //   });
  //   loading.dismiss();
  // }
  
  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      project_code : this.project_code
    }
    this.projectApi.getDetailUsage(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.list = resp.data;
        this.total_amount = resp.total_amount.jumlah;

        loading.dismiss();
        console.log("total amount => ", this.total_amount);
      }else{
        this.navCtrl.pop();
        this.presentToast(this.project_title+" tidak memiliki detail usage budget !");
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
      this.presentToast('ERROR');
      console.log(err);
    });
  }

  // toDetailAdvance(id, item){
  //   this.navCtrl.push(DetailAdvPage, {
  //     cb_request_id:id,
  //     item:item
  //   });
  // }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  localFormating(v){
    v = parseFloat(v);
    v = v.toLocaleString(['ban', 'id']);
    if(v=='NaN'){
      v='-';
    }
    return v;
  }
  localDateFormating(v){
    v = new Date(v);
    v = v.toLocaleString(['ban', 'id']);
    return v;
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/detail_usage/page.ts